import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { GoogleFreeBookingLinksSettingsI18n } from "@/components/features-new/settings-external-connection/google-free-booking-links/settings-i18n";

import { useConfirmParams } from "./hooks";

export const SettingsExternalConnectionGoogleFreeBookingLinksI18nPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID, langCode } = result;

	return (
		<PageMeta
			title="Google無料予約リンクの設定"
			url={generatePath(PATHS.SETTINGS.EXTERNAL_CONNECTION.GOOGLE_FREE_BOOKING_LINKS.I18N, { hotelID, langCode })}
		>
			<GoogleFreeBookingLinksSettingsI18n hotelID={hotelID} langCode={langCode} />
		</PageMeta>
	);
};

SettingsExternalConnectionGoogleFreeBookingLinksI18nPage.displayName =
	"SettingsExternalConnectionGoogleFreeBookingLinksI18nPage";
